import type { LoginSuccessResponse } from '@/api/auth/auth.types'
import type { LoginRedirectSearch } from '@/lib/login-redirect-search'

/**
 * Celular só é considerado válido após OTP (flag `celularConfirmado` do perfil
 * ou `requiresPhoneVerification` na resposta de login).
 */
export function userRequiresPhoneVerification(
  celular: string | null | undefined,
  celularConfirmado?: boolean | null,
): boolean {
  if (!celular?.trim()) {
    return true
  }
  return celularConfirmado !== true
}

export function loginResponseRequiresPhoneVerification(
  tokens: Pick<LoginSuccessResponse, 'requiresPhoneVerification'>,
): boolean {
  return tokens.requiresPhoneVerification === true
}

export function buildCompletarCelularHref(
  search: Pick<LoginRedirectSearch, 'next' | 'return_app'>,
): string {
  const params = new URLSearchParams()
  if (search.next?.trim()) {
    params.set('next', search.next.trim())
  }
  if (search.return_app) {
    params.set('return_app', search.return_app)
  }
  const qs = params.toString()
  return qs ? `/completar-celular?${qs}` : '/completar-celular'
}
